import { render, staticRenderFns } from "./DrugSafeUserIndex.vue?vue&type=template&id=4284930c"
import script from "./DrugSafeUserIndex.vue?vue&type=script&lang=js"
export * from "./DrugSafeUserIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports